<template>
  <div v-if="!!token" class="page-container">
    <div class="import-export-title primary-color import-export-title-margins">
      <v-icon color="secondary" class="arrow-back" @click="goBack()">arrow_back</v-icon>
      <span style="margin-left: 16px">{{ adminText('workflowsAll.export_attendees_70ca2c6', 'Export attendees') }}</span>
    </div>
    <div class="import-export-container import-export-container-margins">
      <div class="import-export-description-margins">
        {{ adminText('workflowsAll.you_can_export_your_attendees_and_all_of_thei_782cbb8', 'You can export your attendees and all of their data here. Choose the appropriate format of the file depending on the purpose.') }}
      </div>
      <div class="import-export-description-margins" style="margin-bottom: 0 !important">
        {{ adminText('workflowsAll.choose_format_f5deef5', 'Choose format:') }}
        <v-radio-group v-model="exportFormat">
          <v-radio color="primary" :label="adminText('workflowsAll.excel_a08e111', 'Excel')" value="xlsx" />
          <v-radio color="primary" label="CSV" value="csv" />
        </v-radio-group>
      </div>
      <div class="import-export-buttons">
        <a
          download
          :href="`${serverURL}/files/events/${eventId}/export/attendees/${exportFormat}/${token}?visible=${visibleFields}`"
        >
          <main-button depressed :text="adminText('workflowsAll.export_attendees_70ca2c6', 'Export attendees')" />
        </a>
      </div>
      <hidden-file-input
        ref="file-input"
        accept="text/csv .csv"
        max-file-size-mb="10"
        @file="processFile($event)"
      />
    </div>
    <div class="import-export-container import-export-container-margins">
      <module-title
        color="#0277BD"
        class="import-export-module-title-margins"
        :title="adminText('workflowsAll.export_analytics_f28b149', 'Export analytics')"
      />
      <div class="import-export-description-margins">
        {{ adminText('workflowsAll.here_you_can_export_a_full_set_of_your_event__49b7bab', 'Here you can export a full set of your event\'s analytics data stored in an Excel file. Analytics contain data such as attendee names, fields, created_at, etc.') }}
      </div>
      <div class="import-export-buttons">
        <a
          download
          :href="`${serverURL}/files/events/${eventId}/export/analytics/xlsx/${token}?visible=${visibleFields}`"
        >
          <main-button depressed :text="adminText('workflowsAll.export_analytics_f28b149', 'Export analytics')" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { getExportToken } from '../../http'
import { encodeExportVisibleFields, getVisibleFields, serverURL } from '../../utils.js'
import HiddenFileInput from './../shared/hidden-file-input'
import ModuleTitle from './../shared/module-title.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'export-container',
  components: {
    HiddenFileInput,
    ModuleTitle,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      serverURL,
      token: undefined,
      exportFormat: 'xlsx',
      visibleFields: undefined,
    }
  },
  async created() {
    const { data } = await getExportToken(this.eventId)
    if (!data) {
      // handle
    }

    this.token = data.token
    const localStorageVisibleFields = getVisibleFields(this.eventId)
    this.visibleFields = encodeExportVisibleFields(localStorageVisibleFields)
  },
}
</script>

<style></style>
